import { render } from "./FormularioSubconta.vue?vue&type=template&id=908cb61c&scoped=true"
import script from "./FormularioSubconta.vue?vue&type=script&lang=js"
export * from "./FormularioSubconta.vue?vue&type=script&lang=js"

import "./FormularioSubconta.vue?vue&type=style&index=0&id=908cb61c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908cb61c"]])

export default __exports__